import React from "react";
import { CopyOutlined } from '@ant-design/icons';
import { Button } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { message } from "antd";
import TextareaAutosize from "react-autosize-textarea";
import "../styles/components/command-popup.scss";

class CommandPopUp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.data ? this.props.data : "",
      copied: false
    };
  }

  onCopy = () => {
    this.setState({ copied: true });
    message.success("Copied!");
  };
  render() {
    return (
      <div className="command-popup">
        <p>{this.props.title}</p>
        <TextareaAutosize
          value={this.props.data}
          onChange={({ target: { value } }) =>
            this.setState({ value, copied: false })
          }
          className="clip-text"
        />
        <CopyToClipboard text={this.props.data} onCopy={this.onCopy}>
          <Button type="primary" shape="round" icon={<CopyOutlined />} className="cpy-clip">
            Copy
          </Button>
        </CopyToClipboard>
      </div>
    );
  }
}

export default CommandPopUp;
